import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AccountSettingsService {
  apiName = 'Default';

  getNotificationEnabled = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>(
      {
        method: 'GET',
        url: `/api/app/account-settings/get-notification-enabled`,
      },
      { apiName: this.apiName, ...config }
    );

  getAIDetectionEnabled = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>(
      {
        method: 'GET',
        url: `/api/app/account-settings/get-ai-detection-enabled`,
      },
      { apiName: this.apiName, ...config }
    );

  setNotificationEnabled = (isEnabled: boolean, config?: Partial<Rest.Config>) =>
    this.restService.request<any, any>(
      {
        method: 'PUT',
        url: `/api/app/account-settings/set-notification-enabled`,
        params: {
          isEnabled,
        },
      },
      { apiName: this.apiName, ...config }
    );

  setAIDetectionEnabled = (isEnabled: boolean, config?: Partial<Rest.Config>) =>
    this.restService.request<any, any>(
      {
        method: 'PUT',
        url: `/api/app/account-settings/set-ai-detection-enabled`,
        params: {
          isEnabled,
        },
      },
      { apiName: this.apiName, ...config }
    );

  deleteMyAccount = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, any>(
      {
        method: 'DELETE',
        url: `/api/app/account-settings/delete-account`,
      },
      { apiName: this.apiName, ...config }
    );
  constructor(private restService: RestService) {}
}
